import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/industries/IndustryTemplate.jsx");
